import { FC, InputHTMLAttributes } from 'react';
import { _js } from '@ifixit/utils/localize';
import { InstantSearch as InstantSearchComponent } from '@ifixit/ui/components/instant-search';
import { getIndexes, getSearchClient, PUBLIC_KEY, isProUser } from 'Guide/searchClient';

interface NanositeMobileSearchProps {
   /** Additional class name for the input element (merged via cn) */
   inputClassName?: string;
   /** Additional input props to pass through */
   inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

/**
 * Mobile InstantSearch component for non-iFixit (nanosite) headers.
 * This is a simplified version that doesn't use Redux state management,
 * suitable for the static nanosite header.
 */
const NanositeMobileSearch: FC<NanositeMobileSearchProps> = ({
   inputClassName,
   inputProps: externalInputProps,
}) => {
   const placeholder = _js('Search');
   const searchClient = getSearchClient();
   const indices = getIndexes();

   // Merge the default className with any external inputClassName and inputProps
   const mergedInputProps = {
      ...externalInputProps,
      className: inputClassName
         ? `rounded-full ${inputClassName}`
         : externalInputProps?.className
           ? `rounded-full ${externalInputProps.className}`
           : 'rounded-full',
   };

   return (
      <InstantSearchComponent
         searchClient={searchClient}
         apiKey={PUBLIC_KEY}
         indices={indices}
         isProUser={isProUser()}
         placeholder={placeholder}
         currency={App.userPreferredStoreCurrency}
         localeCode={App.userPreferredStoreLocale}
         storeCode={App.userPreferredStoreCode}
         inputProps={mergedInputProps}
         popoverProps={{
            sideOffset: 20,
         }}
      />
   );
};

export default NanositeMobileSearch;
